module.exports = __webpack_public_path__ + "src/assets/img/to-draw.4ad2d6d2.png";